module.exports = __webpack_public_path__ + "static/img/01.824d915.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd108/01.png
// module id = fx7/
// module chunks = 1